import { Box, SxProps, Theme, useTheme } from '@mui/material';
import React, { FC, ReactNode } from 'react';

interface CardProps {
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
  children: ReactNode;
  onClick?: () => void;
}

const Card: FC<CardProps> = ({ sx, fullWidth, children, onClick }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: { xs: fullWidth ? '100%' : 'fit-content', sm: '100%' },
        display: 'grid',
        gap: '10px',
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: '4px',
        padding: '5px',
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export default Card;
